module.exports = __webpack_public_path__ + "static/media/U1-T2-3-2.48a329aa.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/U1-T2-3-2.mp3
// module id = 579
// module chunks = 0